/**
 * Created by anthony on 7/8/14.
 */
var emailBlastArchive = angular.module('emailBlastArchive', ['schoolModel']);
emailBlastArchive.factory('EmailBlastArchiveModelFactory', 
    function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory){

    var EmailBlastArchiveModel = function(){
        this.endpoint = '/emailBlastArchive';
        this.primaryKey = 'recordID';
    }
    EmailBlastArchiveModel.prototype = new SchoolModelFactory(this.endpoint);
    EmailBlastArchiveModel.prototype.parent = SchoolModelFactory.prototype;
    EmailBlastArchiveModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        return this.data.push({
            schoolID: schoolID, from: '', fromAddress: '', replyToAddress: '', sentGroup: '', subjectLine: '',
            message: '', dateTime: '', sentSubGroup: '', Year: '', LYA: ''
        }) - 1;

    }
    return EmailBlastArchiveModel;
});


emailBlastArchive.service('EmailBlastArchiveModelService', function(EmailBlastArchiveModelFactory){
    var schoolModel = new EmailBlastArchiveModelFactory();
    return schoolModel;
});


